import { RefBool, Link } from "@tblabs/truffle";
import { BasketOpenerButton } from "./BasketOpenerButton";
import { MenuCloseButton } from "./MenuCloseButton";
import { NavBarLogo } from "./NavBarLogo";
import { NavBarMenu } from "./NavBarMenu";
import { AuthButton } from "./AuthButton";
import { NavBarRight } from "./NavBarRight";
import { SearchButton } from "./SearchButton";
import { Nav } from "../Utils/Nav";
import { Box } from "../Utils/Box";
import { ShopContentProvider } from "../../../Services/Content/ShopContentProvider";
import { BasketProvider } from "../../../Services/BasketProvider";


export class NavBar extends Nav
{
	constructor(private _shop: ShopContentProvider, private _basket: BasketProvider, private _showMiniBasket: RefBool)
	{
		super("navbar navbar--fixed");
	}

	async OnAppend(): Promise<void>
	{
		await this._shop.Load();
		// await this._basket.Load();

		const showMenu = new RefBool(false);

		const menu = {
			"Sprzęt": "kategorie-produktow", // idzie do: strona główna > sekcja kategorii (pod hero)
			"Wypożyczalnia": "wypozyczalnia", // osobna podstrona
			"Kontakt": "kontakt", // osobna podstrona
			"Blog": "blog",
		}

		this.Append(
			new Box("navbar__container", [
				new Box("navbar__content", [
					new NavBarLogo(this._shop.Shop.Logo),
					new NavBarRight(menu),
					new NavBarMenu(this._basket.Basket, showMenu, this._showMiniBasket),
				]), // navbar__content
			]), // navbar__container
			new Box("navbar__mobile-overlay", [
				new MenuCloseButton().OnClick(() => showMenu.False()),
				new Box("navbar__mobile-content", [
					new Box("navbar__mobile-links", [
						...Object.entries(menu)
							.map(([key, value]) =>
								new Link(key, "#" + value)
									.OnClick(() =>
									{
										showMenu.False();
										window.location.hash = value;
									})
									.Class("navbar__mobile-link")),
					]),
					new Box("navbar__mobile-actions", [
						new SearchButton(),
						new BasketOpenerButton(this._basket.Basket).OnClick(() => this._showMiniBasket.True()),
						new AuthButton(),
					]) //.Style("opacity: 0; transform: translateY(10px);"),
				]) //.Style("opacity: 0; transform: translateY(20px);"), // navbar__mobile-content
			]) //.Style(`opacity: 0; display: none;`), // navbar__mobile-overlay
				.Visible(showMenu, "flex")
		);
	}
}
